import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsIceSkateNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M8.84 1.577a3 3 0 013.692 2.002l.136.443a7 7 0 004.817 4.686l2.73.758A3.804 3.804 0 0123 13.131a2.87 2.87 0 01-2.598 2.857l.012.012H21a3 3 0 013 3 2 2 0 01-2 2H2a2 2 0 01-2-2v-1a2 2 0 012-2h.586l.491-.491A3.999 3.999 0 011 12v-.44a5 5 0 01.192-1.373l1.541-5.393a3 3 0 012.06-2.06zM5.415 16l-2 2H2v1h20a1 1 0 00-1-1h-1.414l-2-2h-1.172l-2 2H8.586l-2-2zm3.498-.502l.502.502h4.172l.158-.158a10.732 10.732 0 01-1.56-.393A8.803 8.803 0 009.414 15L9 15.414a2.031 2.031 0 01-.088.084zm1.709-11.33A1 1 0 009.39 3.5L5.342 4.656a1 1 0 00-.687.687l-1.54 5.393A3 3 0 003 11.56V12a2 2 0 002 2h2.586l.42-.42c.373-.373.88-.58 1.403-.58 1.154 0 2.31.186 3.407.551a8.746 8.746 0 002.765.45h4.55a.87.87 0 00.869-.87c0-.81-.54-1.52-1.32-1.738l-2.73-.758a9.035 9.035 0 01-.756-.246L13.8 12.793l-1.417-1.411 1.947-1.955a8.996 8.996 0 01-.803-.61l-1.852 1.86-1.417-1.412 1.898-1.906c-.224-.299-.43-.613-.616-.94L9.48 8.49 8.06 7.077l2.64-2.65z"
        fill=""
      />
    </svg>
  )
);
SvgSportsIceSkateNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsIceSkateNormalSmall;
